import { Box, Button, Grid, LinearProgressProps, Typography, Alert } from '@mui/material';
import { ProgressData } from '../../../../Modules/CentralDataManagement/Imports/IndividualImport/IndividualImport';
import { MDBox } from '../MDBox';
import { MDProgress } from '../MDProgress';
import { MDTypography } from '../MDTypography';
import {MDButton} from "../MDButton";

export const onDownload = (href: string) => {
    const link = document.createElement("a");
    link.download = `errorLog.csv`;
    link.href = href;
    link.click();
};

export const onDownloadWarningLog = (href: string) => {
    const link = document.createElement("a");
    link.download = `warningLog.csv`;
    link.href = href;
    link.click();
}


export function ImportProgressBar(props: LinearProgressProps & { value: number } & { progressData: ProgressData } & { errorLogUrl?: string } & {isExcelImport?: boolean}) {

    return (
        <>
            {(props.progressData?.log == null || props.progressData?.isSuccess == true) && (
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Box sx={{ width: '100%', mr: 1 }}>
                        <MDProgress variant="determinate" {...props} />
                    </Box>
                    <Box sx={{ minWidth: 40 }}>
                        <Typography variant="body2" color="text.secondary">{`${Math.round(props.value,)}%`}</Typography>
                    </Box>
                </Box>
            )}
            <MDBox>
                {props.progressData?.log?.length > 0 && (
                    <Alert severity="error" sx={{mb:1}} icon={false}>
                        <Grid container >
                            <Grid item xs={12} lg={12}>
                                <MDTypography component='span' variant='h5' color='error'>
                                    Import Failed - {props.progressData?.lastSuccessfulStep}
                                </MDTypography>
                                {props.progressData?.numberOfRowsFailed > 0 && (
                                    <MDBox mb={1}>
                                        <MDTypography component='p' variant='body' fontWeight='bold' color='error'>
                                            Number of failed rows: {props.progressData?.numberOfRowsFailed}
                                        </MDTypography>
                                    </MDBox>
                                )}
                                {props.errorLogUrl !== null && (
                                    <MDBox mb={1}>
                                        <MDBox mt={1}>
                                            <MDButton
                                                color='error'
                                                variant="outlined"
                                                onClick={() => {
                                                    onDownload(props.errorLogUrl!)
                                                }}
                                            >
                                                Download Error Log
                                            </MDButton>
                                        </MDBox>
                                        {props.isExcelImport === true && (
                                            <MDTypography component='p' variant='body' fontWeight='regular' color='error' mt={2}>
                                                We encountered an issue with several rows. To see the complete list, kindly download the error log.
                                            </MDTypography>
                                        )}    
                                    </MDBox>
                                )}
                                {props.progressData?.log?.map((error) => (
                                    <MDTypography component='p' variant='body' fontWeight='regular' mb={1} color='error'>
                                        {error}
                                    </MDTypography>
                                ))}
                            </Grid>
                        </Grid>
                    </Alert>
                )}
                {(props.progressData?.numberOfRowsCorrect > 0 || props.value >= 100) && props.progressData?.isSuccess && (
                    <Alert severity="success" sx={{mb:1}} icon={false}>
                        <Grid container >
                            <Grid item xs={12} lg={12}>
                                <MDBox>
                                    <MDTypography component='span' variant='body' fontWeight='bold' color='success'>
                                        Number of correct rows: {props.progressData?.numberOfRowsCorrect}
                                    </MDTypography>
                                </MDBox>
                            </Grid>
                        </Grid>
                    </Alert>
                )}
                {props.progressData?.numberOfRowsCorrect > 0 && !props.progressData?.isSuccess && (
                    <Alert severity="info" sx={{mb:1}} icon={false}>
                        <Grid container >
                            <Grid item xs={12} lg={12}>
                                <MDBox>
                                    <MDTypography component='span' variant='body' fontWeight='bold' color='info'>
                                        Number of valid rows: {props.progressData?.numberOfRowsCorrect}
                                    </MDTypography>
                                </MDBox>
                            </Grid>
                        </Grid>
                    </Alert>
                )}

                {props.progressData?.isSuccess && Array.isArray(props.progressData?.warningLog) && props.progressData?.warningLog?.length > 0 && (
                    <Alert severity="warning" sx={{ mb: 1 }} icon={false}>
                        <Grid container>
                            <Grid item xs={12}>
                                <MDTypography component='span' variant='h5' color='warning'>
                                    Import successful
                                </MDTypography>
                                <MDBox mb={1}>
                                    <MDTypography component='p' variant='body' fontWeight='bold' color='warning'>
                                        Please note: The following employee records were not added to the EE scorecard due to invalid employee type or occupational level.
                                    </MDTypography>
                                </MDBox>
                                {props.progressData.warningLogUrl !== null && (
                                    <MDBox mb={1}>
                                        <MDBox mt={1}>
                                            <MDButton
                                                color='warning'
                                                variant="outlined"
                                                onClick={() => {
                                                    onDownloadWarningLog(props.progressData.warningLogUrl!)
                                                }}
                                            >
                                                Download Warning Log
                                            </MDButton>
                                        </MDBox>   
                                    </MDBox>
                                )}
                                {props.progressData.warningLog?.map((warning, index) => (
                                    <MDTypography key={index} component='p' variant='body' fontWeight='regular' mb={1} color='warning'>
                                        {warning}
                                    </MDTypography>
                                ))}
                            </Grid>
                        </Grid>
                    </Alert>
                )}


            </MDBox>
        </>
    );
}